import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ns-dashboard-api.kabilah.com';

const ClassesContext = createContext();

// GET /api/classes only returns aggregate counts ({id, name, students, cases}
// as numbers) — the full roster (embedded {id,name} students / {id,name,
// description} cases) only comes back from GET /api/classes/:id. Fetching
// every class's detail up front is what lets Students/StudentDetail compute
// "which classes is this student in" without a per-page fetch.
export const ClassesProvider = ({ children }) => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchClasses = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BACKEND_URL}/api/classes`);
      const summaries = Array.isArray(res.data) ? res.data : [];
      const details = await Promise.all(
        summaries.map((summary) =>
          axios.get(`${BACKEND_URL}/api/classes/${summary.id}`)
            .then((r) => r.data)
            // Keep the shape consistent (arrays, not the summary's counts)
            // even if this one class's detail fetch fails.
            .catch(() => ({ ...summary, students: [], cases: [] }))
        )
      );
      setClasses(details);
    } catch {
      setClasses([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchClasses();
  }, [fetchClasses]);

  return (
    <ClassesContext.Provider value={{ classes, setClasses, loading, fetchClasses }}>
      {children}
    </ClassesContext.Provider>
  );
};

export default ClassesContext;
